module.exports = __webpack_public_path__ + "static/graph-6738a6fdd3e87609b444a11bc3e91f7d.svg";